"use client";

import type { RefObject } from "react";
import { useEffect, useState } from "react";

// updates width with respect to another element or to the window width itself
export const useWidthObserver = (ref?: RefObject<HTMLDivElement> | null) => {
  const [windowWidth, setWindowWidth] = useState<number>(0);
  const [windowHeight, setWindowHeight] = useState<number>(0);
  useEffect(() => {
    // timeout to prevent resize being triggered multiple times
    let timeoutId: any = null;
    const handleWindowResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setWindowWidth(ref?.current?.offsetWidth ?? window.innerWidth);
        setWindowHeight(ref?.current?.offsetHeight ?? window.innerHeight);
      }, 300);
    };
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, [ref]);

  // force calling this once on mount used to initialize state since window is only available in useEffect for SSR
  useEffect(() => {
    setWindowWidth(ref?.current?.offsetWidth ?? window.innerWidth);
    setWindowHeight(ref?.current?.offsetHeight ?? window.innerHeight);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isMobile = windowWidth < 768 && windowWidth > 0;
  const isTablet = 768 <= windowWidth && windowWidth < 1024 && windowWidth > 0;
  const isMobileOrTablet = isMobile || isTablet;
  const isDesktop = !isTablet && !isMobile && windowWidth > 0;
  return {
    windowHeight,
    windowWidth,
    isMobile,
    isMobileOrTablet,
    isTablet,
    isDesktop
  };
};
